import React, {useState,  useEffect } from 'react';
import DeckGL, { FlyToInterpolator, WebMercatorViewport } from 'deck.gl';
import { CSVLoader } from '@loaders.gl/csv';

import Slider from '@mui/material/Slider';

import { geojsonIndex  } from './geojsonIndex.js'


import zipLoader from './zipLoader'


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 38.17235759245721,
    longitude: 136.85153168318723,
    bearing: 0,
    pitch: 0,
    zoom: 5
};


function Map() {
    const [sliderValue, setSliderValue] = useState(0);
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE)



    useEffect(()=>{
        const dataset = geojsonIndex.filter((d, i) => i <= sliderValue);
        const minLat = dataset[dataset.length - 1].minLatLng;
        const maxLatLng = dataset[dataset.length - 1].maxLatLng;

        console.log("change", [minLat, maxLatLng])

        
        //座標変換を行うオブジェクトを生成する
        const viewportWebMercator = new WebMercatorViewport({
            width: document.querySelector("#deckgl-wrapper").clientWidth,
            height: document.querySelector("#deckgl-wrapper").clientHeight
        });        

        //指定されたバウンディボックスが画面内に丁度収まる緯度経度とズームレベルを算出する
        let { longitude, latitude, zoom } = viewportWebMercator.fitBounds(
            [
                minLat,
                maxLatLng
            ],
            {
                padding: 10 //地物を画面内に収める際に余白を設定する
            }
        );
        console.log(longitude, latitude, zoom)

        //viewStateを更新しカメラを地物が収まる位置へ移動する
        setViewState((v) => {
            return {
                ...v, // current viewState
                latitude: latitude,
                longitude: longitude,
                zoom: zoom,
                transitionDuration: 1000,
                transitionInterpolator: new FlyToInterpolator()
            };
        });


    }, [sliderValue])



    const HandlerSliderChange = (e,value) => {
        setSliderValue(value)
    }
    


    return (
        <div>
            <DeckGL
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ sliderValue })}
                //onViewStateChange={(v)=>console.log(v.viewState)}
            >
            </DeckGL>
            <fieldset>
                <legend>History of municipal mergers
                    <br/> 
                    <span style={{color:"blue"}}>Takasaki</span> vs <span style={{color:"red"}}>Maebashi</span>
                    </legend>
                <Slider
                    sx={{ 
                        width: 400, 
                        ml:2,
                        mr:2,
                        "& .MuiSlider-thumb": {
                            color: "#089bad",
                            width: 8,
                            borderRadius: 0
                        },
                        "& .MuiSlider-track": {
                            color: "#089bad",
                        },
                        "& .MuiSlider-mark":{
                            backgroundColor:"green"
                        },
                        "& .MuiSlider-markLabel":{
                            color:"white",
                            fontFamily: "Mohave, sans- serif"
                        }
                    }}
                    aria-label="Custom marks"
                    defaultValue={0}
                    step={1}
                    max={8}
                    valueLabelDisplay="off"
                    marks={geojsonIndex}
                    onChange={HandlerSliderChange}
                />           
            </fieldset>
            
            <div className="attribution">
                <a
                    href="https://geoshape.ex.nii.ac.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                ©Geoshapeリポジトリ
                </a>

                <a
                    style={{marginLeft:"1em"}}
                    href="https://www.mapbox.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    ©Mapbox
                </a>
            </div>
        </div>
    );
}

export default Map;